import { detectPortal, Portal } from './common/util/detect-portal';
import { Environment, getEnvironment } from './common/util/environment';
import { initPwaInstallPromptCapture } from './common/util/pwa-install-event';

// Has to run before any await, otherwise the browser's beforeinstallprompt event is missed.
initPwaInstallPromptCapture();

const portal = detectPortal();

if (portal === Portal.SPP) {
    const { bootstrap } = await import('./spp/bootstrap');
    await bootstrap();
} else if (portal === Portal.TEST_GEN && getEnvironment() !== Environment.PRODUCTION) {
    const { bootstrap } = await import('./test_gen/bootstrap');
    await bootstrap();
} else {
    const { bootstrap } = await import('./cpp/bootstrap');
    await bootstrap();
}
